



































import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
import shareSlot from "./shareSlot.vue";
@Component({
  components: {
    shareSlot,
  },
})
export default class extends Vue {
    notShare:boolean = true;
    sharePoster(){
      this.notShare = false;
      (this.$refs as any).shareSlot.createImage();
    }
    goAppoint(){
      this.$router.push({
        path:'/',
        query:{
          id:'appoint'
        }
      })
    }
}
